import { render, staticRenderFns } from "./CardImageView.vue?vue&type=template&id=b1d1d782&scoped=true&"
import script from "./CardImageView.vue?vue&type=script&lang=js&"
export * from "./CardImageView.vue?vue&type=script&lang=js&"
import style0 from "./CardImageView.vue?vue&type=style&index=0&id=b1d1d782&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d1d782",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default})
